/**
 * Created by inonstelman on 12/29/14.
 */
(function () {
    "use strict";

    // @ngInject
    function HoneyTipsManager($q, APIService, Routes, ModelFactory) {
        this.constructor.$super.call(this, APIService, ModelFactory, $q);
        this.Routes = Routes;
    }

    Services.HoneyTipsManager = Class(Services.BaseModelManager, {
        constructor: HoneyTipsManager,

        getRandomTip: function getRandomTip() {
            var tip = this.ModelFactory.newHoneyTipModel();
            var url = this.Routes.v2_honey_tip_get_path();
            this.apiFetch(url, null, tip, true);
            return tip;
        },

        likeTip: function likeTip(tip) {
            var url = this.Routes.v2_honey_tip_like_path(tip._id);
            this.apiCreate(url, {});
        }
    });
}());
